import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import { LOCATION, CONTACT } from '../../data/siteContent';
import Icon from '../common/Icon';

const QUICK_LINKS = [
  { label: 'Home',        to: '/'            },
  { label: 'About',       to: '/about'       },
  { label: 'Services',    to: '/services'    },
  { label: 'Products',    to: '/products'    },
  { label: 'Our Process', to: '/our-process' },
  { label: 'Technology',  to: '/technology'  },
  { label: 'Contact',     to: '/contact'     },
];

const INDUSTRY_LINKS = [
  { label: 'Healthcare IT',      to: '/industries/healthcare'     },
  { label: 'EdTech Platforms',   to: '/industries/edtech'         },
  { label: 'ERP & Automation',   to: '/industries/erp-automation' },
  { label: 'SaaS Products',      to: '/industries/saas'           },
  { label: 'Enterprise Software',to: '/industries/enterprise'     },
];

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container">
        <div className="row gy-5">

          {/* Column 1 — Brand */}
          <div className="col-lg-4 col-md-6">
            <Link to="/" className="footer-logo" aria-label="Quantum Stack – home">
              <img src={logo} alt="Quantum Stack" className="site-logo__img" />
            </Link>
            <p className="footer-tagline">
              Software engineering and digital solutions built around your
              requirements — plus our own product line. Founded in 2024 and based in
              Pimpri-Chinchwad, Maharashtra, India.</p>
          </div>

          {/* Column 2 — Quick Links */}
          <div className="col-lg-2 col-md-3 col-6">
            <h3 className="footer-heading">Navigation</h3>
            <ul className="footer-links">
              {QUICK_LINKS.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Industries */}
          <div className="col-lg-3 col-md-3 col-6">
            <h3 className="footer-heading">Industry Solutions</h3>
            <ul className="footer-links">
              {INDUSTRY_LINKS.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Contact */}
          <div className="col-lg-3 col-md-6">
            <h3 className="footer-heading">Contact</h3>
            <address style={{ fontStyle: 'normal' }}>
<div className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true"><Icon name="mail" size={18} /></span>
                <a href="mailto:contact@quantum-stack.com">contact@quantum-stack.com</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true"><Icon name="phone" size={18} /></span>
                <a href="tel:+917558793773">+91 75587 93773</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true"><Icon name="pin" size={18} /></span>
                <a href={LOCATION.mapsUrl} target="_blank" rel="noopener noreferrer" aria-label="Open our address in Google Maps">
                  {LOCATION.lines.map((l, i) => (<React.Fragment key={l}>{i > 0 && <br />}{l}</React.Fragment>))}
                </a>
              </div>
            <div className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true"><Icon name="linkedin" size={18} /></span>
                <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer">Follow us on LinkedIn</a>
              </div>
            </address>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom__inner">
            <p className="footer-copyright">
              &copy; {currentYear} Quantum Stack Pvt Ltd. All rights reserved.
            </p>
            <nav aria-label="Legal links">
              <div className="footer-legal-links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
